import { GET_TRYST_HOST } from "../constants/env";
import fetchWrapper from "../fetch-client";

const createReceiptPdfV2 = async ({
  pdfObject,
}: {
  pdfObject: any;
}): Promise<{
  success: boolean;
  receipt_url?: string;
  error?: string;
}> => {
  const TRYST_HOST = GET_TRYST_HOST();
  try {
    const requestOptions: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        pdfObject,
      }),
      redirect: "follow",
      mode: "cors",
      credentials: "include",
    };

    const response = await fetchWrapper(
      `${TRYST_HOST}/business/receipt/pdf-v2`,
      requestOptions
    );

    const data = await response.json();

    if (!data?.success) {
      console.error("ERROR ======> createReceiptPdfV2: API failed", data.error);
      return {
        success: false,
        error: data?.error || "PDF generation failed",
      };
    }

    return {
      success: true,
      receipt_url: data.data?.receipt_url,
    };
  } catch (err) {
    console.error("ERROR ======> createReceiptPdfV2: Request failed", err);
    return {
      success: false,
      error: "Failed to generate receipt PDF",
    };
  }
};

export default createReceiptPdfV2;
